import { Box, Typography, Link, ListItem } from "@mui/material";
import { INicu } from "../types/interfaces/INicu";
import NicuDetail from "./NicuDetail";
import { useEffect, useState } from "react";
import { DisplayParms } from "../types/classes/DisplayParms";

//This function creates a nicu summary.
export default function NicuSummary(props: {nicu: INicu, index: number, displayParms: DisplayParms, onDisplayChange: (displayParms: DisplayParms) => void}) {
    if (props.nicu == null) return (<></>);

    const[show, setShow] = useState(props.displayParms.ResetShowFlag);

    const handleOnClick = () => {
        if(props.displayParms.ResetShowFlag)
        {
            let newDisplayParms: DisplayParms = new DisplayParms();
            newDisplayParms.Page = props.displayParms.Page;
            newDisplayParms.ResetShowFlag = false;
            props.onDisplayChange(newDisplayParms);
        }
        setShow(prev => !prev);
    };

    useEffect(() => {
        if(props.displayParms.ResetShowFlag) {
            setShow(false);
        }
    }, [props.displayParms.ResetShowFlag]);

    //show nicu list items with alternate background colors.
    function GetNicuItem()
    {
        if(props.index % 2){
            return (
                <>
                <ListItem sx={{bgcolor: '#ECEFF1'}}>
                    <Box sx={{minWidth: 400}}><Link color="secondary.light" sx={{fontWeight: "bold"}} component="button" onClick={handleOnClick}>{props.nicu.Name}</Link></Box>
                    <Typography color="secondary.dark">{props.nicu.City}, {props.nicu.State} {props.nicu.Zip}</Typography>
                </ListItem>
                <ListItem sx={{bgcolor: '#ECEFF1'}}>
                    {!props.displayParms.ResetShowFlag && show && <Box><NicuDetail nicu={props.nicu} /></Box>}
                </ListItem>
                </>
            );
        }
        else {
            return (
                <>
                    <ListItem>
                        <Box sx={{minWidth: 400}}><Link color="secondary.light" sx={{fontWeight: "bold"}} component="button" onClick={handleOnClick}>{props.nicu.Name}</Link></Box>
                        <Typography color="secondary.dark">{props.nicu.City}, {props.nicu.State} {props.nicu.Zip}</Typography>
                    </ListItem>
                    <ListItem>
                        {!props.displayParms.ResetShowFlag && show && <NicuDetail nicu={props.nicu} />}
                    </ListItem>
                </>
            );
        }
    }

    return (
        <>
            {GetNicuItem()}
        </>
    );
}